import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CardSlider from "../components/Slider/CardSlider";
import TitleHero from "../components/Hero/TitleHero";
import Page from "../layout/Page";
import axios from "axios";
import moment from "moment";

const data = [
  {
    publisher: "India Today",
    publishedOn: "Jan 2, 2024",
    headline:
      "The Uttar Pradesh government has made CCTV cameras mandatory in all school vehicles to ensure the safety of children.",
    link: "https://www.indiatoday.in/india/story/uttar-pradesh-cctv-cameras-mandatory-uttar-pradesh-school-vans-children-safety-2483119-2024-01-02",
  },
  // Add more news items here
];
const Newsroom = () => {
  const [news, setNews] = useState([]);

  const fetchNews = async () => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/insights/news`
      );
      if (res?.status === 200) {
        console.log("news :", res?.data);
        setNews(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNews();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="Newsroom | Shoora"
      description="Shoora news"
      keywords="shoora, newsroom, government, mandates, safety"
    >
      <TitleHero title="NEWSROOM" />
      <div className="featured-news">
        <div className="container">
          <div className="row row-cols-1 row-cols-md-2 align-items-center">
            <div className="col">
              <p className="text-accent fw-bold text-capitalize mb-4">
                FEATURED NEWS
              </p>
              <h1 className="mb-4">
                Shoora unveils its latest school bus solution, designed to meet
                Government of India mandates.
              </h1>
              <Link to="#" className="btn btn-dark rounded-5">
                Read more
              </Link>
            </div>
            <div className="col">
              <img
                src="https://images.pexels.com/photos/26202099/pexels-photo-26202099/free-photo-of-vehicles-driving-through-a-flooded-street.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                alt=""
                className="w-100"
              />
            </div>
          </div>
        </div>
      </div>
      {Array.isArray(news) && news?.length ? (
        <div className="published-news">
          <div className="container">
            <div className="stories-header">
              <h2>Shoora in the news</h2>
            </div>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-gap-5 my-5">
              {news?.map((item, i) => (
                <div key={i} className="col">
                  <h3 className="fw-bold">{item.publisher}</h3>
                  <p style={{ color: "gray", fontFamily: "Lora" }}>
                    <i>{moment(item.createdAt).format("MMMM Do, YYYY")}</i>
                  </p>
                  <h4>
                    <Link
                      to={item?.newsSrcUrl || item.link}
                      target="_blank"
                      className="text-decoration-none text-dark"
                    >
                      {item.title}
                    </Link>
                  </h4>
                </div>
              ))}
              {/* <div className="col">
                            <h3 className='fw-bold'>
                                IT Pro Today
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                Forbes
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                Forbes
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                Information Week
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                Fast Company
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                HR Dive
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                Consulting.us
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div>
                        <div className="col">
                            <h3 className='fw-bold'>
                                The Fast Mode
                            </h3>
                            <p style={{ color: 'gray', fontFamily: "Lora" }}><i>August 2, 2024</i></p>
                            <h4>
                                <a href="#" className="text-decoration-none text-dark">
                                    Financial Times highlights solutions created by Spot, a Boston Dynamics robot dog powered by Google’s Gemini Pro model created by Shoora
                                </a>
                            </h4>
                        </div> */}
            </div>
          </div>
        </div>
      ) : null}
      <div className="announcement">
        <div className="resources-section">
          <div className="container">
            <CardSlider title={`Shoora Announcements`} />
          </div>
          <p className="text-center my-5">
            <a
              href="#"
              className="btn btn-outline-dark btn-lg rounded-5 border-0 fw-bold"
            >
              See archive <i class="fa-solid fa-circle-right"></i>
            </a>
          </p>
        </div>
      </div>
      <div className="media">
        <div className="container">
          <div className="py-5">
            <h1>
              <i className="text-accent text-lora">Media</i> & asset inquiries
            </h1>
            <p>
              For media and asset inquiries, please contact us at{" "}
              <a href="mailto:info@shoora.com" className="text-decoration-none">
                <i>info@shoora.com</i>
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Newsroom;
